import { render, staticRenderFns } from "./DetailPromo.vue?vue&type=template&id=db002b5a&scoped=true"
import script from "./DetailPromo.vue?vue&type=script&lang=js"
export * from "./DetailPromo.vue?vue&type=script&lang=js"
import style0 from "./DetailPromo.vue?vue&type=style&index=0&id=db002b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db002b5a",
  null
  
)

export default component.exports